"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const Role_1 = __importDefault(require("./Role"));
const OfficeRole_1 = __importDefault(require("./OfficeRole"));
class Rule extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = Rule;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["updateOfficeRole"], message: "UID is required" }),
    __metadata("design:type", String)
], Rule.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createRule"], message: "Name is required" }),
    __metadata("design:type", String)
], Rule.prototype, "name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createRule"], message: "Name is required" }),
    __metadata("design:type", String)
], Rule.prototype, "label", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Rule.prototype, "namespace", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Rule.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], Rule.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Role_1.default),
    __metadata("design:type", Array)
], Rule.prototype, "role", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeRole_1.default),
    __metadata("design:type", Array)
], Rule.prototype, "officeRole", void 0);
